export const ENDPOINT = {
    BASE_URL: process.env.VUE_APP_BASE_URL,
    API: '/api',
    EXTERNAL_API: '/api_ext',
    LOGIN: '/login',
    OTP: '/otp',
    VERIFY: '/verify',
    LOGOUT: '/logout',
    INTROSPECTION: '/me',
    LANGUAGE: '/language',
    USER: '/user',
    USERS: '/users',
    CENTERS: '/centers',
    PATIENTS: '/patients',
    THERAPIES: '/therapies',
    THERAPY_SCHEME: '/therapy_scheme',
    THERAPY_TREND: '/therapytrend',
    INTAKES: '/intakes',
    STATS: '/stats',
    SURVEYS: '/surveys',
    SURVEY_STEPS: '/survey_steps',
    STEPS: '/steps',
    RESPONSES: '/responses',
    RECOVERY_PASSWORD: '/recovery_password',
    RESET_PASSWORD: '/reset_password',
    RESET_PASSWORD_REQUEST: '/reset_password_code',
    UPDATE_PASSWORD: '/password',
    ROLES: '/roles',
    ADD_ROLE: '/add-role',
    REMOVE_ROLE: '/remove-role',
    PERMISSIONS: '/permissions',
    CONTENTS: '/contents',
    CONTENT_CATEGORIES: '/content_categories',
    CONTENT_CATEGORY_PERMISSION: '/content_category_permissions',
    CONTENT_BLOCKS: '/blocks',
    ACTIVE: '/active',
    CONSENTS: '/consents',
    USER_CONSENT_VERSION: '/user_consent_versions',
    VERSIONS: '/versions',
    HCP_MESSAGES: '/hcp_messages',
    EVENTS: '/events',
    EVENT_TYPES: '/event_type',
    SEARCH: '/search',
    EXTRA_DATA: '/dataextra',
    EXTRA_DEFINITIONS: '/dataextra_definitions',
    EXTRA_DEFINITION_VALUES: '/dataextra_values',
    STOP: '/stop',
    STATISTICS: '/statistics',
    LIST_HCPS: '/list_hcps',
    HCPS: '/hcps',
    LABELS: '/labels',
    SUPPORT: '/support-request-web',
    INVITATIONS: '/invitations',
    ACCEPT: '/accept',
    ZONES: '/zones',
    PRIVACY: '/privacy',
    PORTABILITY: '/portability',
    RIGHT_TO_ERASURE: '/right-to-erasure',
    EXPERIENCE_JOURNEY: '/experience_journey',
    SCHEMAS: '/schemes',
    ORDER: '/order',
    ADVERSE_EVENT_CONFIG: '/adverse-event-config',
}